module.exports = __webpack_public_path__ + "media/application/images/svgs/facebook-7f47d1e3a5f4d8b4c5862bed686b1be3.svg";